var _path, _circle, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSubsectionLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 51,
    viewBox: "0 0 36 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.813 24.458l-.83-.557.83.557zm4.024-9.097a1 1 0 001.92-.564l-1.92.564zm2.427 3.146a1 1 0 10-1.973-.334l1.973.334zm-3.728 1.496a1 1 0 001.25 1.562l-1.25-1.562zm-.958 3.743a1 1 0 10-1.553-1.26l1.553 1.26zm-3.57 1.858a1 1 0 101.812.846l-1.812-.846zm1.322 3.722a1 1 0 00-1.958.407l1.958-.407zm.284 3.936a1 1 0 101.317-1.505l-1.317 1.505zm4.139.36a1 1 0 00-.95 1.76l.95-1.76zm2.338 3.382a1 1 0 10.851-1.81l-.851 1.81zm4.138-.212a1 1 0 00-.925 1.773l.925-1.773zm-6.886-22.984c.196.58.36 1.095.494 1.553l1.92-.564a42.598 42.598 0 00-.52-1.63l-1.894.64zm.948 4.366c-.048.286-.161.486-.413.737-.311.31-.695.574-1.342 1.092l1.25 1.562c.507-.406 1.09-.826 1.504-1.237.472-.471.84-1.031.974-1.821l-1.973-.334zm-4.266 4.311c-.339.418-.687.887-1.042 1.416l1.66 1.115c.323-.48.635-.9.935-1.27l-1.553-1.26zm-1.042 1.416a12.754 12.754 0 00-.975 1.703l1.812.846c.207-.443.478-.92.823-1.434L9.983 23.9zm-1.611 5.832c.297 1.431 1.157 2.58 2.242 3.529l1.317-1.505c-.888-.777-1.422-1.569-1.601-2.43l-1.958.406zm5.43 5.648c1.05.566 2.177 1.1 3.289 1.623l.851-1.81c-1.117-.525-2.197-1.037-3.19-1.573l-.95 1.76zm6.502 3.184c.53.277 1.04.558 1.52.849l1.035-1.712a29.866 29.866 0 00-1.63-.91l-.925 1.773z",
    fill: "#613400"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.801,
    cy: 12,
    r: 3,
    fill: "#FFFEF8",
    stroke: "#613400",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.802,
    cy: 39,
    r: 3,
    fill: "#FFFEF8",
    stroke: "#613400",
    strokeWidth: 2
  })));
}

export default __webpack_public_path__ + "./fonts/SubsectionLink.901a6a81828e9c2cee67cdb267124a14.svg";
export { SvgSubsectionLink as ReactComponent };